import { useTranslation } from 'react-i18next'
import { SegmentedControl } from './ui/SegmentedControl.js'

// MapStyleSwitcher — shared basemap style switch used inside RouteMap (and
// any future map surface). Pulls labels through i18n so RouteEditor /
// RouteDetail / Discover pick up the active locale automatically.

export type MapStyleValue = 'standard' | 'outdoor' | 'satellite'

export interface MapStyleSwitcherProps {
  value: MapStyleValue
  onChange: (next: MapStyleValue) => void
  /** Subset of styles to expose; defaults to all four. */
  styles?: ReadonlyArray<MapStyleValue>
  className?: string
}

const DEFAULT_STYLES: ReadonlyArray<MapStyleValue> = ['standard', 'outdoor', 'satellite']

export function MapStyleSwitcher({
  value,
  onChange,
  styles = DEFAULT_STYLES,
  className,
}: MapStyleSwitcherProps) {
  const { t } = useTranslation('common')
  return (
    <SegmentedControl<MapStyleValue>
      ariaLabel={t('mapStyle.ariaLabel')}
      className={className}
      value={value}
      onChange={onChange}
      options={styles.map((s) => ({
        value: s,
        label: t(`mapStyle.${s}`),
        testid: `map-style-${s}`,
      }))}
    />
  )
}
